import { h } from 'preact';
import React from 'react';

import injectQueryParams from '../../injectQueryParams';
import Children from './Children';
import { NoticeSettings } from './NoticeSettings';
import noticeStarter from './noticeStarter';

import './notice.css';

export class Notice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choices: [],
      components: props.messageId ? [{}] : noticeStarter,
      siteId: null,
      current: [0],
      loading: true,
      actions: [],
      width: 0,
      height: 0,
      devOpts: { hideRowColumnBorder: false, }
    };
  }

  componentDidMount = () => {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    const { messageId } = this.props;
    // IF MESSAGE ID
    if (messageId) {
      fetch(`${this.props.mmsOrigin}/message?message_id=${messageId}`, { insecure: true })
      .then(r => r.json())
      .then(data => {
          try {
            const parsedComponents = JSON.parse(data.message_json);
            const components = Array.isArray(parsedComponents) ? parsedComponents : [parsedComponents];
            this.setState({
              components,
              choices: data.message_choice || [],
              type: components[0].settings.type,
              siteId: data.site_id || null,
              loading: false
            }, () => {
              window.addEventListener('message', this.handleMessages, false);
              window.parent.postMessage({ name: 'sp.showMessage', actions: [], settings: components[0].settings }, '*');
              this.setState({ actions: [] });
            });
          } catch (e) {
            console.error('Could not parse message data', e);
          }
        });
    } else if (this.props.dev || this.props.tiny || this.props.mini) {
      this.setState({ loading: false });
      window.addEventListener('message', this.handleDev, false);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleDev);
    window.removeEventListener('message', this.handleMessages);
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    if (!this.state.loading && (this.state.type === 'top' || this.state.type === 'bottom' || this.state.type === 'inline')) {
      const noticeComponent = this.state.components ? this.state.components[0] : {};
      const Settings = new NoticeSettings(noticeComponent.settings || {});
      window.parent.postMessage({
        name: 'sp.resizeMessage',
        type: this.state.type,
        height: this.noticeRef ? this.noticeRef.clientHeight + ((Settings.border.borderWidth || 0) * 2) : 0,
        showVeil: Settings.showVeil,
      }, '*');
    }
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  makeChoice = (choiceId) => {
    let choice = this.state.choices.find(c => c.button_text === choiceId);

    // If no choice found, I want to go ahead and dismiss the message
    if (!choice) choice = this.state.choices.find(c => c.type === 15); 

    const actions = this.state.actions.concat({
      type: "choice",
      data: choice
    });
    this.setState({ actions }, () => {
      if (choice.type) {
        window.parent.postMessage(
          { name: 'sp.hideMessage', actions: actions }, '*',
        );
        this.setState({ actions: [] });
      }
    })
  }

  dismissNotice = () => {
    this.makeChoice('Dismiss');
  }

  handleMessages = ({ data }) => {
    if (data.name === 'sp.choiceAction' && data.type) {
      const choice = this.state.choices.find(c => c.type === data.type);
      if (choice) {
        window.parent.postMessage({ name: 'sp.hideMessage', actions: [{ type: "choice", data: choice }] }, '*');
      }
    }
  }


  handleDev = (event) => {
    if (event.data && typeof event.data === 'string') {
      const messageData = JSON.parse(event.data);
      this.setState({
        devOpts: messageData.devOpts || {},
        components: messageData.components,
        current: messageData.current,
        siteId: messageData.siteId
      });
    }
  }

  noticeSetCurrent = (newCurrent, e) => {
    let target = e.target === e.currentTarget;
    if (e.currentTarget.className.includes('text')) target = true;
    if (e.currentTarget.className.includes('message-stacks')) target = true;
    if (target) {
      window.parent.postMessage({ action: 'dev.setCurrent', newCurrent }, '*')
    }
  };

  doAction = (action) => window.parent.postMessage({ action }, '*')

  render() {
    const noticeComponent = this.state.components ? this.state.components[0] : {};

    const components = noticeComponent.children || [];
    const Settings = new NoticeSettings(noticeComponent.settings || {});
    let noticeClass = this.props.dev ? 'message message-dev' : 'message';

    const styles = {
      ...Settings.padding,
      ...Settings.border
    }, closeStyles = { ...Settings.closeFont }, veilStyles = {};

    styles.background = Settings.background;

    /* WIDTH & HEIGHT */
    const { paddingTop, paddingBottom, paddingLeft, paddingRight } = Settings.padding;
    styles.width = Settings.width.type === 'auto' ? 'auto' : Settings.width.value + Settings.width.type;
    styles.height = Settings.height.type === 'auto' ? 'auto' : Settings.height.value + Settings.height.type;
    if (Settings.height.type === '%') {
      styles.height = `calc(${Settings.height.value}% - ${(paddingTop + paddingBottom)}px`;
    }
    if (Settings.width.type === '%' && (Settings.type === 'top' || Settings.type === 'bottom')) {
      styles.width = `calc(${Settings.width.value}% - ${(paddingLeft + paddingRight)}px`;
    }

    /* Close Button */
    if (Settings.showClose) {
      if (Settings.closeAlign === 'left') {
        closeStyles.right = 'auto';
        closeStyles.left = '20px';
        closeStyles.textAlign = 'left';
      } else {
        closeStyles.left = 'auto';
        closeStyles.right = '20px';
        closeStyles.textAlign = 'right';
      }
      closeStyles.zIndex = 2147483646;
    } else {
      closeStyles.display = 'none';
    }

    /* VEIL STYLES */
    veilStyles.display = Settings.showVeil ? 'flex' : 'none';
    veilStyles.background = Settings.veilColor;
    veilStyles.opacity = Settings.veilOpacity;


    const preview = this.props.tiny || this.props.mini;
    const fixed = Settings.type === 'top' || Settings.type === 'bottom';
    const scale = this.props.mini ? 0.4 : 0.2;
    if (preview) {
      styles.transform = `scale(${scale}) translateX(-50%) translateY(-50%)`;
      if (fixed) styles.transform = `scale(${scale}) translateX(-50%)`;
      styles.transformOrigin = Settings.type === 'bottom' ? 'left bottom' : 'left top';
      noticeClass = noticeClass + ' message-mini';
    }
    if (preview && (fixed || Settings.width.type !== 'px')) {
      const previewWidth = this.props.mini ? 364 : 160;
      const percent = fixed || Settings.width.type === 'auto' ? 100 : Settings.width.value;
      const scaledWidth = ((1 / scale) * previewWidth * (100 / percent)) - (paddingLeft + paddingRight);
      styles.width = scaledWidth + 'px';
    }

    if (Settings.type === 'modal') noticeClass += ' type-modal';
    if (Settings.type === 'top') noticeClass += ' type-top';
    if (Settings.type === 'bottom') noticeClass += ' type-bottom';

    const dev = {
      current: JSON.stringify(this.state.current || [0]),
      opts: this.state.devOpts,
      add: () => this.doAction('dev.add'),
      templates: () => this.doAction('dev.templates'),
      hover: {
        onClick: (e) => {
          e.preventDefault();
          const target = e.target && e.target.getAttribute('path') ? JSON.parse(e.target.getAttribute('path')) : null;
          if (target) {
            this.noticeSetCurrent(target, e);
          } else if (!target && e.currentTarget && (e.currentTarget.className.includes('text') || e.currentTarget.className.includes('message-stacks'))) {
            const newTarget = e.currentTarget && e.currentTarget.getAttribute('path') ? JSON.parse(e.currentTarget.getAttribute('path')) : null;
            if (newTarget) this.noticeSetCurrent(newTarget, e);
          }
        },
        onMouseOver: (e) => {
          e.preventDefault();
          let target = e.target;
          if (e.currentTarget.className.includes('text')) target = e.currentTarget;
          if (e.currentTarget.className.includes('message-stacks')) target = e.currentTarget;
          if (target.className.includes('message-component')) target.id = 'on-hover';
        },
        onMouseOut: (e) => {
          e.preventDefault();
          let target = e.target;
          if (e.currentTarget.className.includes('text')) target = e.currentTarget;
          if (e.currentTarget.className.includes('message-stacks')) target = e.currentTarget;
          target.id = '';
        }
      }
    };

    const notice = (
      <div ref={element => this.noticeRef = element} className={noticeClass} style={styles}>
        <div className="message-stacksclose" onClick={this.dismissNotice} style={closeStyles}>X</div>
        {Children({
          path: [0],
          dev: this.props.dev ? dev : null,
          components: components,
          siteId: this.state.siteId,
          message: Settings,
          makeChoice: this.makeChoice,
          width: this.state.width,
          preview: preview,
        })}
      </div>
    );

    const emptyNotice = (
      <div id="empty-notice" role="presentation">
        <button onClick={this.props.dev ? dev.add : null} className="empty-add">+ Add Components</button>
        <div className="empty-or">or</div>
        <button className="empty-template" onClick={this.props.dev ? dev.templates : null}>Start from Template</button>
      </div>
    );

    const noticeContainer = (
      <div className="message-container">
        <div className="message-overlay" style={veilStyles} />
        {components.length ? notice : emptyNotice}
      </div>
    );
  
    if (this.state.loading) return <div className="loader">Loading...</div>;
    return this.props.mini || this.props.tiny ? notice : noticeContainer;
  }
}

export default injectQueryParams(Notice);